import { useEffect } from 'react';

import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

import { newRelic } from './newRelic';
import { FeatureFlags, useFeatureFlag } from '../featureflagsV2';

const useSetupNewRelic = () => {
  const newRelicFeatureFlag = useFeatureFlag(FeatureFlags.WEBAPP_NEW_RELIC);

  useEffect(() => {
    if (newRelic.isInitialized()) return;
    if (!CONFIG.newRelic.enabled) return;
    if (!newRelicFeatureFlag?.enabled) return;

    const instance = new BrowserAgent({
      info: {
        applicationID: CONFIG.newRelic.applicationId,
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        jsAttributes: {},
        licenseKey: CONFIG.newRelic.licenseKey,
        sa: 1,
      },
      init: {
        ajax: { deny_list: ['bam.nr-data.net'] },
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
      },
      loader_config: {
        accountID: CONFIG.newRelic.accountId,
        agentID: CONFIG.newRelic.agentId,
        applicationID: CONFIG.newRelic.applicationId,
        licenseKey: CONFIG.newRelic.licenseKey,
        trustKey: CONFIG.newRelic.trustKey,
      },
    });

    newRelic.setInstance(instance);
  }, [newRelicFeatureFlag]);
};

export const NewRelicMonitor = () => {
  useSetupNewRelic();

  return null;
};
